/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  Button,
  FormHelperText,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import { DataGrid } from '@material-ui/data-grid';
import { toast } from 'react-toastify';
import { Delete } from '@material-ui/icons';
import { Link } from 'react-router-dom';
import {
  InputText,
  InputRadio, InputRadioGroup
} from '@aldridge/aldg-data-components';
import { useRecoilState, useSetRecoilState } from 'recoil';
import Confirm from '../_GlobalComponents/Confirm';
import { firestore } from '../firebase';
import { UserContext } from '../providers/UserProvider';
import SortableList from '../_DataComponents/SortableList';
import { InputTypeahead } from '../_DataComponents/FormFields';
import { _AllCategories, _AllSubcategories } from '../_Recoil/atoms';
import { basicStyles } from './theme';
import ErrorBoundary from '../_helpers/ErrorBoundary';

const CategoriesList = (props) => {
  const { history } = props;
  const [setups, setSetups] = useState([]);
  const [AllCategories] = useRecoilState(_AllCategories);
  const screenSizeWarning = () => <Alert severity="info">
    <AlertTitle>Attention</AlertTitle>
    Please use a tablet or computer to properly access this page!
  </Alert>;

  useEffect(() => {
    let mounted = true;
    console.log(AllCategories)
    if (mounted)
      setSetups(AllCategories);
    return () => { mounted = false; };
  }, [AllCategories]);
  const onSelect = (id) => {
    history.push(`/Categories/${id}`);
  };
  const [deleteState, setDeleteState] = useState({
    proceedLabel: 'Delete',
    cancelLabel: 'Cancel',
    title: 'Delete Category',
    modalBody: 'Are you sure you want to remove this Category? Removing it will break some Inspections.',
    show: false,
    // eslint-disable-next-line no-use-before-define
    proceed: (approved, r) => { removeRecord(approved, r); },
    enableEscape: true
  });
  const removeRecord = (a, r) => {
    if (a) {
      if (r.idx !== '') {
        firestore.collection('Categories').doc(r.idx).delete();
      }
    }
    setDeleteState({ ...deleteState, show: false });
  };
  const handleDelete = (idx) => {
    setDeleteState({ ...deleteState, show: true, record: { idx } });
  };

  const classes = basicStyles();

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));

  const getFlex = (f) => (matches ? null : f);

  const getWidth = (w) => (matches ? w : null);

  const columns = [
    {
      field: 'CategoryDisplay', headerName: 'Category (Display)',
      valueGetter: (params) => params.row.data.CategoryDisplay,
      valueFormatter: (params) => params.row.data.CategoryDisplay, flex: getFlex(1),
      width: getWidth(400)
    },
    {
      field: 'Category', headerName: 'Category',
      valueGetter: (params) => params.row.data.Category,
      valueFormatter: (params) => params.row.data.Category, flex: getFlex(1),
      width: getWidth(400)
    },
    {
      field: 'SafetyAbsolute', headerName: 'Safety Absolute',
      valueGetter: (params) => params.row.data.SafetyAbsolute,
      valueFormatter: (params) => params.row.data.SafetyAbsolute, flex: getFlex(.6),
      width: getWidth(200)
    },
    {
      field: 'Delete', headerName: 'Delete', sortable: false, filterable: false, flex: getFlex(.2), width: getWidth(100), align: 'right', renderCell: (params) =>
        <div><Delete style={{ cursor: 'pointer' }} onClick={(e) => { e.stopPropagation(); handleDelete(params.row.id); }} /></div>
    }
  ];
  return (
    <ErrorBoundary componentName="Categories List">
      {matches ? screenSizeWarning() : null}

      <Confirm
        proceedLabel={deleteState.proceedLabel}
        cancelLabel={deleteState.cancelLabel}
        title={deleteState.title}
        modalBody={deleteState.modalBody}
        show={deleteState.show}
        proceed={deleteState.proceed}
        enableEscape={deleteState.enableEscape}
        record={deleteState.record}
      />
      <div style={{
        position: 'sticky', top: 0, left: 0, right: 0, backgroundColor: 'white', width: '100%', display: 'flex', justifyContent: 'flex-end'
      }}
      >
        <Link style={{ margin: '16px' }} to="Categories/new"><Button variant="contained" color="primary">New Category</Button></Link>
      </div>
      <div style={{
        width: '100%', display: 'flex', justifyContent: 'flex-end'
      }}
      />
      <div style={{ height: '100%' }}>
        <DataGrid
          className={classes.catRoot}
          getRowId={(row) => row.id}
          rows={setups}
          columns={columns}
          density={matches ? 'compact' : 'standard'}
          filterModel={{
            items: [
              { columnField: 'CategoryDisplay', operatorValue: 'contains', value: '' },
              { columnField: 'Category', operatorValue: 'contains', value: '' },
              { columnField: 'SafetyAbsolute', operatorValue: 'contains', value: '' },
            ],
          }}
          onRowClick={(a) => { onSelect(a.row.id); }}
        />
      </div>
    </ErrorBoundary>
  );
};

CategoriesList.propTypes = {
  history: PropTypes.objectOf(PropTypes.any)
};
CategoriesList.defaultProps = {
  history: {}
};

const Categories = (props) => {
  const { match, history } = props;
  const [saving, setSaving] = useState(false);
  const [subcategories, setSubcategories] = useState([]);
  const [AllCategories, setAllCategories] = useRecoilState(_AllCategories);
  const [AllSubcategories] = useRecoilState(_AllSubcategories);

  const user = useContext(UserContext);
  const [record, setRecord] = useState({
    id: '',
    CreatedDate: '',
    CreatedBy: '',
    ModifiedBy: '',
    ModifiedDate: '',
    data: {
      Category: '',
      Status: 'Active',
      SafetyAbsolute: 'No',
      Subcategories: [],
    }
  });
  useEffect(() => {
    let mounted = true;
    firestore.collection('Categories').doc(match.params.id).onSnapshot((snap) => {
      if (snap.exists) {
        const d = snap.data();
        if (mounted)
          setRecord(d);
      }
      else if (mounted) {
        setRecord({ ...record, id: snap.id });
      }
    });
    return () => { mounted = false; };
  }, [match]);

  useEffect(() => {
    let mounted = true;
    if (mounted)
      setSubcategories(AllSubcategories);
    return () => { mounted = false; };
  }, [AllSubcategories]);

  const handleSubmit = () => {
    setSaving(true);
    const colRef = firestore.collection('Categories');
    colRef.doc(record.id).set(record, { merge: true });
    setSaving(false);
    const allNewCategories = JSON.parse(JSON.stringify(AllCategories))
    const idx = allNewCategories.findIndex(opt => opt.id === record.id)
    if (idx > -1) {
      allNewCategories[idx] = record
    } else {
      allNewCategories.push(record)
    }
    setAllCategories(allNewCategories)
    toast.success('Category Saved Successfully.', { autoClose: 5000 });
    history.push('/Categories');
  };
  const handleChange = (event, name, displayFromTypeahead) => {
    try {
      const id = name || event.target.name;
      const value = typeof name !== 'undefined' ? event : event.target.value;
      const changeRecord = { ...record };
      changeRecord.data[id] = value;
      if (typeof displayFromTypeahead !== 'undefined') {
        changeRecord.data[`${id}Display`] = displayFromTypeahead;
      }
      if (changeRecord.CreatedBy === '') {
        changeRecord.CreatedBy = user.email;
        changeRecord.CreatedDate = new Date().toJSON();
      }
      changeRecord.ModifiedBy = user.email;
      changeRecord.ModifiedDate = new Date().toJSON();
      setRecord(changeRecord);
    }
    catch (err) {
      toast.error(err.message);
    }
  };

  const addSubcategory = (e, v) => {
    const updatedRecord = { ...record };
    if (v === null || typeof v === 'undefined') return;
    if (updatedRecord.data.Subcategories.filter((res) => res.id === v.value).length === 0) {
      const subRecord = subcategories.filter((res) => res.id === v.value);
      if (subRecord.length > 0) {
        updatedRecord.data.Subcategories.push(subRecord[0]);
        setRecord(updatedRecord);
      }
    }
  };
  const removeFromList = (idx) => {
    const updatedRecord = { ...record };
    updatedRecord.data.Subcategories.splice(idx, 1);
    setRecord(updatedRecord);
  };
  const updateOrder = (reOrdered) => {
    const updatedRecord = { ...record };
    updatedRecord.data.Subcategories = reOrdered;
    setRecord(updatedRecord);
  };
  return (
    <ErrorBoundary componentName="Categories (Not the List view)">

      {
        saving ? (
          <div style={{
            display: 'block', position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: '#efefef', opacity: 0.5, zIndex: 100
          }}
          />
        ) : <></>
      }
      <div style={{
        position: 'sticky', top: 0, left: 0, right: 0, width: '100%', backgroundColor: 'white', paddingTop: '10px', paddingBottom: '5px', paddingLeft: '0px', display: 'flex', justifyContent: 'flex-end', zIndex: 100
      }}
      >
        <Button variant="contained" color="primary" onClick={handleSubmit}>Save</Button>
        <Link style={{ textDecoration: 'none' }} to="/Categories"><Button variant="contained" style={{ marginLeft: '5px', color: "black" }}>Close</Button></Link>
      </div>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <InputText name="Category" value={record.data.Category || ''} label="Category" onChange={handleChange} />
        </Grid>
        <Grid item xs={12}>
          <InputText name="CategoryDisplay" value={record.data.CategoryDisplay || ''} label="Category (Display)" onChange={handleChange} />
        </Grid>
        <Grid item xs={6}>
          <InputRadioGroup name="Status" value={record.data.Status || ''} label="Status" onChange={handleChange}>
            <InputRadio value="Active" label="Active" style={{ transform: 'scale(1.25)' }} />
            <InputRadio value="Inactive" label="Inactive" style={{ transform: 'scale(1.25)' }} />
          </InputRadioGroup>
          <FormHelperText>Inactivating a Category will only
            prevent this from showing up for future Inspections.
          </FormHelperText>
        </Grid>
        <Grid item xs={6}>
          <InputRadioGroup name="SafetyAbsolute" value={record.data.SafetyAbsolute || ''} label="Is This Category a Safety Absolute?" onChange={handleChange}>
            <InputRadio value="Yes" label="Yes" style={{ transform: 'scale(1.25)' }} />
            <InputRadio value="No" label="No" style={{ transform: 'scale(1.25)' }} />
          </InputRadioGroup>
        </Grid>
        <Grid item xs={12}>
          {console.log(subcategories)}
          <InputTypeahead label="Add a Subcategory" name="Sub" onChange={addSubcategory} options={subcategories.map((res) => ({ label: res.data.Subcategory, value: res.id }))} clearOnBlur blurOnSelect disableClearable />
          <SortableList options={record.data.Subcategories || []} displayKey="Subcategory" updateOrder={updateOrder} removeFromList={removeFromList} />
        </Grid>
      </Grid>
    </ErrorBoundary>
  );
};

Categories.propTypes = {
  history: PropTypes.objectOf(PropTypes.any),
  match: PropTypes.objectOf(PropTypes.any),
};
Categories.defaultProps = {
  history: {},
  match: {}
};
export {
  CategoriesList, Categories
};
